import { RouteObject } from 'react-router-dom'
import { PageLayout } from '$components/common'
import { default as Connection } from '.'

export const connectionRoutes: RouteObject[] = [
  {
    path: '/connection/complete',
    element: (
      <PageLayout title="Complete connection" htmlTitleOnly>
        <Connection.Connection.Component />
      </PageLayout>
    ),
    loader: Connection.Connection.Loader,
    handle: { noTopbar: true },
  },
]
